import { supabase } from "./supabase";

// Card processing-fee config (owner directive 2026-06-17). Single-row table
// `payment_settings`. 2.7% card-present (terminal), 2.9% card-not-present
// (manual key-in / saved card / online / shop / memberships). Read by both the
// front-end charge flows and the edge functions.

const DEFAULTS = {
  cc_fee_enabled: false,
  cc_fee_present_pct: 2.7,
  cc_fee_notpresent_pct: 2.9,
  cc_fee_label: "Card Processing Fee",
};

let _cache = null;
let _cacheAt = 0;

export async function loadPaymentSettings(force = false) {
  const now = Date.now();
  if (!force && _cache && now - _cacheAt < 60000) return _cache;
  try {
    const { data } = await supabase.from("payment_settings").select("*").eq("id", 1).single();
    if (data) { _cache = data; _cacheAt = now; }
  } catch (_) { /* fall back to cache / defaults */ }
  return _cache || DEFAULTS;
}

// present = true for the physical terminal (card-present), false for any
// online / keyed-in / saved-card / recurring charge (card-not-present).
export function cardFeePct(present, s) {
  if (!s || !s.cc_fee_enabled) return 0;
  const pct = present ? Number(s.cc_fee_present_pct) : Number(s.cc_fee_notpresent_pct);
  return pct > 0 ? pct : 0;
}

export function cardFeeFor(amount, present, s) {
  const pct = cardFeePct(present, s);
  if (!pct) return 0;
  return Math.round((Number(amount) || 0) * pct) / 100; // = amount * pct/100, 2dp
}

export function feeLabel(s) {
  return (s && s.cc_fee_label) || DEFAULTS.cc_fee_label;
}
